import { useEffect } from 'react';

// import { socket } from 'src/components/socket';
import { socket } from 'src/components/socket';
import { useSetUsers } from 'src/common/recoil/room';
import { Move } from 'src/common/types/global';

export const useSocketDraw = (drawing: boolean) => {
  const { handleAddMoveToUser, handleRemoveMoveFromUser } = useSetUsers();

  useEffect(() => {
    let moveToDrawLater: Move | undefined;
    let userIdLater = '';

    socket.on('user_draw', (move:any, userId:any) => {
      if (!drawing) {
        handleAddMoveToUser(userId, move);
      } else {
        moveToDrawLater = move;
        userIdLater = userId;
      }
    });

    return () => {
      socket.off('user_draw');

      if (moveToDrawLater && userIdLater) {
        handleAddMoveToUser(userIdLater, moveToDrawLater);
      }
    };
  }, [drawing, handleAddMoveToUser]);

  useEffect(() => {
    socket.on('user_undo', (userId:any) => {
      handleRemoveMoveFromUser(userId);
    });

    return () => {
      socket.off('user_undo');
    };
  }, [handleRemoveMoveFromUser]);
};
